export default __webpack_public_path__ + "static/media/EventPlanner.cd332e02.jpg";